import React, { useEffect, useRef } from 'react'

const location = {
  lat: 37.4575847,
  lng: 127.1284629,
  title: '동서울웨딩컨벤션',
  displayTitle: '예식장',
}

const KakaoMap: React.FC = () => {
  const mapContainer = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (mapContainer.current && window.kakao && window.kakao.maps) {
      const mapOption = {
        center: new window.kakao.maps.LatLng(location.lat, location.lng),
        level: 3,
      }

      const map = new window.kakao.maps.Map(mapContainer.current, mapOption)

      const markerPosition = new window.kakao.maps.LatLng(location.lat, location.lng)

      const imageSrc = 'https://t1.daumcdn.net/localimg/localimages/07/mapapidoc/marker_red.png'
      const imageSize = new window.kakao.maps.Size(64, 69)
      const imageOption = { offset: new window.kakao.maps.Point(27, 69) }

      const markerImage = new window.kakao.maps.MarkerImage(imageSrc, imageSize, imageOption)

      const marker = new window.kakao.maps.Marker({
        position: markerPosition,
        image: markerImage,
      })

      marker.setMap(map)

      const iwContent = `
        <div style="padding:5px;width: 170px;text-align: center;">
          ${location.displayTitle} <br>
          <a href="https://map.kakao.com/link/map/${location.title},${location.lat},${location.lng}" style="color:blue" target="_blank">${location.title}</a> 
        </div>`

      const infowindow = new window.kakao.maps.InfoWindow({
        position: markerPosition,
        content: iwContent,
      })

      infowindow.open(map, marker)
    }
  }, [])

  return (
    <div style={{ position: 'relative', width: '100%', height: '400px' }}>
      <div ref={mapContainer} className='z--20' style={{ width: '100%', height: '100%' }} />
      <div
        style={{
          position: 'absolute',
          left: 0,
          width: '100%',
          height: '100%',
          background: 'transparent',
          zIndex: 1,
          pointerEvents: 'none',
        }}
      />
    </div>
  )
}

export default KakaoMap
